import {Button, Col, InputGroup, Nav, Navbar, Row} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import React from "react";
import {useNavigate, useParams} from "react-router-dom";
import {Formik} from "formik";
import axios from "axios";

export default function Step3(props){
    let navigate = useNavigate();
    let { module } = useParams();

    function backStep(){
        props.cb(1,props.data)
    }

    function saveStep(values){
        props.data.atlas=values.atlas;
        // props.data.optional.template=values.template;
        props.data.allowUpload=values.allowUpload;
        props.data.allowView=values.allowView;
        props.data.allowCompare=values.allowCompare;
        props.data.allowDelete=values.allowDelete;
        // if(props.data.deadline !== "")
        props.data.deadline=  new Date(props.data.deadline).toISOString();
        props.cb(2,props.data);



        const formData = new FormData();
        for (const fileName in props.data.files) {
            if( props.data.files[fileName] instanceof FileList){
                props.data.files[fileName]= props.data.files[fileName][0];
            }
            formData.append(fileName, props.data.files[fileName]);
        }


        return new Promise((resolve, reject) => {
            axios.post(  "/api/case/"+module, props.data).then(res => {
                if(res.data === ""){
                    reject({error: true,message: "Module does not exist"});
                    return;
                }
                 axios.post("/api/case/"+res.data.id+"/files", formData).then(res2 => {
                     resolve(res);
                 }).catch(err => {
                     alert("One or more of the files does not meet the requirement of being a dicom file or for the images zipped dicom files");
                     reject({error: true,message: err});
                 });
            }).catch(err => {
                alert("Something went wrong, please retry from step 1");
                reject({error: true,message: err});
            });
        });
    }

    return(
        <>

            <Formik
                initialValues={{ atlas: props.data.atlas,template: '', allowUpload:props.data.allowUpload, allowView:props.data.allowView, allowCompare: props.data.allowCompare, allowDelete: props.data.allowDelete}}
                validate={values => {
                    const errors = {};
                    return errors;
                }}
                onSubmit={(values, { setSubmitting }) => {
                    saveStep(values).then((r) => {
                        setSubmitting(false);
                        navigate('/')
                    })
                }}
            >
                {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      isSubmitting,
                      setFieldValue
                      /* and other goodies */
                  }) => (
                    <form onSubmit={handleSubmit}>
                        <Row  style={{  marginTop: "20px"}}>
                            <Navbar bg="light" variant="light">

                                <Nav>
                                    <Button onClick={backStep} variant="secondary" >
                                        Back
                                    </Button>
                                </Nav>
                                <Nav className="m-auto">
                                    <p className="m-auto">1. General Information <span className="m-3">-</span> 2. Upload Case Files <span className="m-3">-</span> <b>3. Additional Information</b></p>
                                </Nav>
                                <Nav>

                                    <Button type="submit" disabled={isSubmitting} variant="primary" >
                                        Create
                                    </Button>
                                </Nav>
                            </Navbar>
                        </Row>
                        <Row className="mt-5">

                            <h5>
                                Provide Atlas link
                            </h5>
                            <hr/>
                            <Col lg={6}>
                                <span style={{color: "red"}}>{errors.atlas && touched.atlas && errors.atlas}</span>
                                <InputGroup className="mb-3">
                                    <span className="input-group-text">Atlas link:</span>
                                    <Form.Control
                                        aria-label="atlas"
                                        placeholder=""
                                        name="atlas"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.atlas}
                                    />
                                </InputGroup>
                            </Col>


                        </Row>
                        {/*<Row className="mt-5">*/}
                        {/*    <h5>*/}
                        {/*        Upload Scoring Region*/}
                        {/*    </h5>*/}
                        {/*    <hr/>*/}
                        {/*    <Col lg={6}>*/}
                        {/*        <span style={{color: "red"}}>{errors.template && touched.template && errors.template}</span>*/}
                        {/*        <Form.Group controlId="formFile" className="mb-3">*/}
                        {/*            <Form.Label>Upload a scoring region in the form of a DICOM structure which could be overlaid on top of the uploaded images when necessary.</Form.Label>*/}
                        {/*            <Form.Control name="template" type="file" onChange={(event) => {*/}
                        {/*                setFieldValue("template", event.currentTarget.files[0]);*/}
                        {/*            }}/>*/}
                        {/*        </Form.Group>*/}
                        {/*    </Col>*/}
                        {/*</Row>*/}
                        <Row className="mt-5">
                            <h5>
                                Student Permissions
                            </h5>
                            <hr/>
                            <Col lg={6}>
                                <Form.Check
                                    type="switch"
                                    label="Allow download and upload"
                                    name="allowUpload"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    checked={values.allowUpload}
                                />
                                <Form.Check
                                    type="switch"
                                    label="Allow view"
                                    name="allowView"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    checked={values.allowView}
                                />
                                <Form.Check
                                    type="switch"
                                    label="Allow compare to gold standard"
                                    name="allowCompare"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    checked={values.allowCompare}
                                />
                                <Form.Check
                                    type="switch"
                                    label="Allow delete own work"
                                    name="allowDelete"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    checked={values.allowDelete}
                                />
                            </Col>
                        </Row>
                    </form>
                )}
            </Formik>

        </>
    )
}